<template lang="jade">
ul.list-unstyled
  li(v-for="d in data")
    a(href="#" '@click'="select(d)" ':class'="{active: d == value}") {{d}}
  
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    data: {
      type: Array,
      required: true,
    }, 
    value: {
      type: String,
      required: true,
    }
  },
  computed: {},
  ready () {},
  attached () {},
  methods: {
    select(d) {
      this.value = d
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
@import "global";

li {
  margin-bottom: 1em;
  a {
    color: $gray-light;
  }
  a.active {
    color: $brand-primary;
  }
}
</style>



// WEBPACK FOOTER //
// filter-list.vue?630325c2